import React from "react";
import { useActionsProvidersIndex, useDispatchProvidersIndex, useProviders } from "../../../../context/inventory/ProvidersIndexProvider";
import { LineTitle } from "../../article";
import { CreateProvider } from "../form/CreateProvider";
import "../form/CreateProvider.css";
import Pagination from "../../../app/atoms/Pagination";
import { types } from "../../../../reducers/inventory/providersReducer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan, faBuilding, faBuildingCircleXmark } from "@fortawesome/free-solid-svg-icons";
import { OrderColumns } from "../../../app/atoms/OrderColumns";
import Moment from "react-moment";
import { FORMAT_DATE_TIME_MOMENT } from "../../../../api/constant";

export const ProvidersIndex = () => {
  const state = useProviders();
  const dispatch = useDispatchProvidersIndex();
  const action = useActionsProvidersIndex();
  const { filter } = state;
  const sortBy = filter.sortBy ?? "name";
  const sortDir = filter.sortDir ?? "asc";

  const setSort = (newSortBy, newSortDir) => {
    dispatch({ type: types.CHANGE_INPUT_FILTER_PROVIDERS, payload: { name: "sortBy", value: newSortBy } });
    dispatch({ type: types.CHANGE_INPUT_FILTER_PROVIDERS, payload: { name: "sortDir", value: newSortDir } });
  };

  return (
    <div className="container-fluid">
      <LineTitle title="Lista de proveedores" />
      <CreateProvider />
      <LineTitle />

      <table className="table table-provider">
        <thead className="thead-dark thead-provider">
          <tr>
            <th scope="col">
              <div className="flex">
                <OrderColumns
                  label="ID"
                  sortBy={sortBy}
                  sortDir={sortDir}
                  onClickAsc={() => setSort("id", "asc")}
                  onClickDesc={() => setSort("id", "desc")}
                />
              </div>
            </th>
            <th scope="col">
              <div className="flex">
                <OrderColumns
                  label="Nombre"
                  sortBy={sortBy}
                  sortDir={sortDir}
                  onClickAsc={() => setSort("name", "asc")}
                  onClickDesc={() => setSort("name", "desc")}
                />
              </div>
            </th>
            <th scope="col">
              <div className="flex">
                <OrderColumns
                  label="Documento"
                  sortBy={sortBy}
                  sortDir={sortDir}
                  onClickAsc={() => setSort("doc_num", "asc")}
                  onClickDesc={() => setSort("doc_num", "desc")}
                />
              </div>
            </th>
            <th scope="col">Teléfono</th>
            <th scope="col">Email</th>
            <th scope="col">Ciudad</th>
            <th scope="col">
              <div className="flex">
                <OrderColumns
                  label="Fecha de creación"
                  sortBy={sortBy}
                  sortDir={sortDir}
                  onClickAsc={() => setSort("created_at", "asc")}
                  onClickDesc={() => setSort("created_at", "desc")}
                />
              </div>
            </th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>
          {state.elements.map((item) => (
            <tr
              key={item.id}
              className="cursor-pointer td-hoverme"
              onClick={() => action.goToProviderEdit(item.id)}
            >
              <td>{item.id}</td>
              <td>{item.name}</td>
              <td>{item.doc_num}</td>
              <td>{item.phone ?? "—"}</td>
              <td>{item.email ?? "—"}</td>
              <td>{item.city ?? "—"}</td>
              <td className="text-center">
                {item.created_at ? (
                  <Moment format={FORMAT_DATE_TIME_MOMENT}>{item.created_at}</Moment>
                ) : (
                  "—"
                )}
              </td>
              <td onClick={(e) => e.stopPropagation()} className="d-flex gap-1">
                {item.assigned_to_current_company ? (
                  <button
                    type="button"
                    className="btn btn-link btn-sm p-0 text-warning"
                    title="Desasignar de mi compañía"
                    onClick={() => action.unassignProviderToCompanyClick(item.id)}
                  >
                    <FontAwesomeIcon icon={faBuildingCircleXmark} />
                  </button>
                ) : (
                  <button
                    type="button"
                    className="btn btn-link btn-sm p-0"
                    title="Asignar a mi compañía"
                    onClick={() => action.assignProviderToCompanyClick(item.id)}
                  >
                    <FontAwesomeIcon icon={faBuilding} />
                  </button>
                )}
                <button
                  type="button"
                  className="btn btn-link btn-sm text-danger p-0"
                  title="Eliminar"
                  onClick={() => action.deleteProviderClick(item.id)}
                >
                  <FontAwesomeIcon icon={faTrashCan} />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="flex justify-end">
        <Pagination
          onChangepage={(e) =>
            dispatch({
              type: types.CHANGE_INPUT_FILTER_PROVIDERS,
              payload: { name: "page", value: e },
            })
          }
          page={state.filter.page}
          limit={state.filter.limit}
          rows={state.rows}
        />
      </div>
    </div>
  );
};
